import Vue from 'vue';
import Router from 'vue-router';
import { homePageRouter } from '@/views/homePage/router';
import { quotationListRouter } from '@/views/quotationlist/router';
import { creatOrderFirst } from '@/views/creatorderfirst/router';
import { creatOrderSecond } from '@/views/creatordersecond/router';
import { creatOrderThird } from '@/views/creatorderthird/router';
import { creatOrderFourth } from '@/views/creatorderfourth/router';
import { exportOrder } from '@/views/exportorder/router';
import { additionProduct } from '@/views/additionproduct/router';
import { addedProduct } from '@/views/addedproduct/router';
import { selectAccessories } from '@/views/selectaccessories/router';
import { switchUserRouter } from '@/views/switchUser/router';
import { orderDetail } from '@/views/orderdetail/router';
import { selectProduct } from '@/views/selectproduct/router';
import { preciseAssociation } from '@/views/preciseAssociation/router';
import { settings } from '@/views/person/router';
import { systemAuthorizationRouter } from '@/views/systemAuthorization/router';
Vue.use(Router);

export const constantRouterMap = [
  // { path: '/404', name: '404', component: () => import('@/views/404'), hidden: true },
  { path: '/error403', name: 'error403', component: () => import('@/views/error403'), hidden: true },
  { path: '/historyRecord', name: 'historyRecord', component: () => import('@/views/historyRecord'), hidden: true },
  { path: '/ChanPx', name: 'ChanPx', component: () => import('@/views/components/ChanPx'), hidden: true },
  { path: '/modelChange', name: 'modelChange', component: () => import('@/views/modelChange'), hidden: true },
  { path: '/',
    name: 'main',
    component: () => import('../views/Home.vue'),
    hidden: true,
    redirect: 'main',
    children: [
      {
        path: 'home',
        meta: {
          activename: 'home'
        },
        component: () => import('@/views/Home')
      }
    ]
  }

  // { path: '*', redirect: '/404', hidden: true }

];

export default new Router({
  mode: 'history', // 后端支持可开
  // base: '/web/',
  scrollBehavior: () => ({ y: 0 }),
  routes: [...constantRouterMap, ...quotationListRouter, ...creatOrderFirst, ...creatOrderSecond, ...creatOrderThird, ...creatOrderFourth, ...exportOrder, ...additionProduct, ...addedProduct, ...selectAccessories, ...orderDetail, ...homePageRouter, ...switchUserRouter,
    ...selectProduct, ...preciseAssociation, ...settings, ...systemAuthorizationRouter]
});
// 获取原型对象上的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err);
};
